/** Reconnect backoff schedule (spec §21): 1s, 2s, 5s, 10s, then capped at 30s. */
const SCHEDULE_MS = [1_000, 2_000, 5_000, 10_000, 30_000];

export function backoffDelayMs(attempt: number): number {
  const index = Math.min(attempt, SCHEDULE_MS.length - 1);
  return SCHEDULE_MS[index];
}
